
export class Civilite {
  id: string;
  libelle: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/civilite.model.ts